import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Personal from './pages/Personal';
import Sadhana from './pages/Sadhana';
import './styles/App.css';

const App = () => {
  return (
    <MantineProvider>
      <DatesProvider settings={{ locale: 'en' }}>
        <Router>
          <div className="app">
            <Header />
            <main style={{ padding: 0, margin: 0 }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/personal" element={<Personal />} />
                <Route path="/sadhana" element={<Sadhana />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </DatesProvider>
    </MantineProvider>
  );
};

export default App;